
angular.module('ecrd')
    .controller('RecordQueriesFiltersController', [function() {
        var vm = this;

        vm.$onInit = function() {
            vm.filters = {
                status: '',
                type: '',
                lastReply: '',
            };

            vm.order = 'created_at_desc';
        };

        vm.filterQueries = function() {
            vm.onFilterQueries({
                filters: vm.filters,
                order: vm.order,
            });
        };
    }]);